module.exports = __webpack_public_path__ + "img/MACHO_+24.218fc799.jpeg";